import { carriers } from './carriers'
import { pickupSchedule } from './pickupSchedule'
import type { CarrierPickupTime } from './types'

export const carrierPickupTimes: readonly CarrierPickupTime[] = carriers.map((carrier) => ({
  carrierId: carrier.id,
  weekdays: `${pickupSchedule.windowLabel} Central Time`,
  saturday: 'No Pickup',
  sunday: 'No Pickup',
  note: `Monday–Friday, ${pickupSchedule.windowLabel} Central Time. No pickup on weekends or USPS holidays.`,
  verified: true,
}))
